module.exports = __webpack_public_path__ + "static/media/jaybox_logo_light_icon_white.ce0837e6.svg";